import React, { useState, useEffect, useRef } from "react";
import "./index.css";

import homeSection1RightImg from "../assests/HomeImg/home-section-1-right-img.png";
import homeSection3MapImage from "../assests/HomeImg/homeSection3MapImage.png";
import manufacturingApprovalsIcon from "../assests/CDMOImages/Manufacturing Approvals & Certifications-icon.svg";

import homeSectionRightImg1 from "../assests/HomeImg/homeSectionRightImg1.png";
import homeSectionRightImg2 from "../assests/HomeImg/homeSectionRightImg2.png";
import homeSectionRightImg3 from "../assests/HomeImg/homeSectionRightImg3.png";
import homeSectionRightImg4 from "../assests/HomeImg/homeSectionRightImg4.png";
import homeSectionRightImg5 from "../assests/HomeImg/homeSectionRightImg5.png";

import homeSectionRightImgbottomicon from "../assests/HomeImg/homeSectionRightImgbottomicon.png";

import section1Icon1 from "../assests/HomeImg/home-section1-icon1.svg";
import section1Icon2 from "../assests/HomeImg/home-section1-icon2.svg";
import section1Icon3 from "../assests/HomeImg/home-section1-icon3.svg";
import section1Icon4 from "../assests/HomeImg/home-section1-icon4.svg";

import homeAPIIcon from "../assests/HomeImg/home-API-icon.svg";
import homeHumanHealthIcon from "../assests/HomeImg/Human Health-icon.svg";
import homeAnimalHealthIcon from "../assests/HomeImg/Animal Health-icon.svg";
import homeCDMOServicesIcon from "../assests/HomeImg/CDMO Services-icon.svg";

import homeFacilitiesIcon from "../assests/HomeImg/home-Facilities-icon.svg";
import homeCountriesIcon from "../assests/HomeImg/home-Countries-icon.svg";
import homeUnitsYearIcon from "../assests/HomeImg/home-UnitsYear-icon.svg";

import section2img from "../assests/HomeImg/section2-img.svg";

import homeSection4Icon1 from "../assests/HomeImg/home-section4-top-card-icon1.svg";
import homeSection4Icon2 from "../assests/HomeImg/home-section4-top-card-icon2.svg";
import homeSection4Icon3 from "../assests/HomeImg/home-section4-top-card-icon3.svg";
import homeSection4Icon4 from "../assests/HomeImg/home-section4-top-card-icon4.svg";

import homeSection4Image from '../assests/HomeImg/home-section4-image.png';
import HomeCommitmentIcon1 from "../assests/HomeImg/Home-commitment-icon1.svg";
import HomeCommitmentIcon2 from "../assests/HomeImg/Home-commitment-icon2.svg";
import HomeCommitmentIcon3 from "../assests/HomeImg/Home-commitment-icon3.svg";
// import GlobalCertificationsApprovalsIcon from "../assests/HomeImg/Global Certifications & Approvals-icon.svg";

// import homeFDAIcon from "../assests/HomeImg/home-FDA-icon.svg";
// import homeEMAIcon from "../assests/HomeImg/home-EMA-icon.svg";
// import homeWHOGMPIcon from "../assests/HomeImg/home-WHO-GMP-icon.svg";
// import homeISO90012015Icon from "../assests/HomeImg/home-ISO90012015-icon.svg";
// import homeISO14001Icon from "../assests/HomeImg/home-ISO14001-icon.svg";
// import homeOHSAS18001Icon from "../assests/HomeImg/home-OHSAS18001-icon.svg";

import homeRevenueIcon from "../assests/HomeImg/Revenue-icon.svg";
import homePatentsFiledIcon from "../assests/HomeImg/Patents Filed-icon.svg";
import homeGrowthEbitdaIcon from "../assests/HomeImg/Growth in EBITDA-icon.svg";
import homeNetDebtIcon from "../assests/HomeImg/Net Debt-icons.svg";

import homeFinancialReportsIcon from "../assests/HomeImg/Financial Reports-icon.svg";
import homeCorporateGovernanceIcon from "../assests/HomeImg/Corporate Governance-icon.svg";
import homeShareholderInfoIcon from "../assests/HomeImg/Shareholder Information-icon.svg";
import homeEventsEarningsIcon from "../assests/HomeImg/Events & Earnings-icon.svg";

import homeWaterSavedIcon from "../assests/HomeImg/Water Saved-icon.svg";
import homeWasteRecycledIcon from "../assests/HomeImg/Waste Recycled-icon.svg";
import homeEmployeeSatisfactionIcon from "../assests/HomeImg/Employee Satisfaction-icon.svg";

import homeEnvironmentalStewardshipIcon from "../assests/HomeImg/Environmental Stewardship-icon.svg";
import homePeopleCultureIcon from "../assests/HomeImg/People & Culture-icons.svg";
import homeSocialImpactIcon from "../assests/HomeImg/Social Impact-icon.svg";

import homeUNSDGsIcon from "../assests/HomeImg/UN Sustainable Development Goals-icon.svg";

import homeCustomersIcon from "../assests/HomeImg/home-Customers-icon.svg";
import homePartnersIcon from "../assests/HomeImg/home-Partners-icon.svg";
import homeInvestorsIcon from "../assests/HomeImg/home-Investors-icon.svg";
import homeCareersIcon from "../assests/HomeImg/home-Careers-icon.svg";
import homeNotSureIcon from "../assests/HomeImg/Notsure-icon.svg";
import { CiLineHeight } from "react-icons/ci";

const stats = [
    { value: "40+", label: "Years of Excellence", icon: section1Icon1 },
    { value: "15+", label: "Manufacturing Facilities", icon: section1Icon2 },
    { value: "150+", label: "Countries Served", icon: section1Icon3 },
    { value: "100%", label: "Regulatory Compliance", icon: section1Icon4 },
];

// Custom hook for counter animation
function useCounter(target, duration = 1500) {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const start = performance.now();
                    const tick = (now) => {
                        const elapsed = now - start;
                        const progress = Math.min(elapsed / duration, 1);
                        setCount(Math.floor(progress * target));
                        if (progress < 1) requestAnimationFrame(tick);
                        else setCount(target);
                    };
                    requestAnimationFrame(tick);
                }
            },
            { threshold: 0.3 }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [target, duration]);

    return { count, ref };
}

// Animated stat item
function StatItem({ stat }) {
    const match = stat.value.match(/^(\d+)(.*)$/);
    const numeric = match ? parseInt(match[1], 10) : 0;
    const suffix = match ? match[2] : stat.value;
    const { count, ref } = useCounter(numeric);

    return (
        <div ref={ref} className="home-section1-stat">
            <img src={stat.icon} alt={stat.label} className="home-section1-home-section3-stat-icon" />
            <span className="home-section1-stat-value">
                {count}{suffix}
            </span>
            <span className="home-section1-stat-label">{stat.label}</span>
        </div>
    );
}

// Flexible animated counter
function AnimatedCounter({ value, className }) {
    const match = value.match(/^([^0-9]*)(\d+(?:\.\d+)?)(.*)$/);
    const prefix = match ? match[1] : '';
    const numeric = match ? parseFloat(match[2]) : 0;
    const suffix = match ? match[3] : value;
    const isFloat = String(match?.[2]).includes('.');
    const { count, ref } = useCounter(numeric, 1800);

    return (
        <span ref={ref} className={className}>
            {prefix}{isFloat ? count.toFixed(1) : Math.floor(count)}{suffix}
        </span>
    );
}

// Investor section stat card with animation
function InvestorStatCard({ item }) {
    return (
        <div className="hoome-section5-stat-card">
            <div className="hoome-section5-icon">
                <img src={item.icon} alt={item.title} />
            </div>
            <div>
                <div className="hoome-section5-home-section3-stat-title">
                    <AnimatedCounter value={item.title} className="hoome-section5-home-section3-stat-title" />
                </div>
                <div className="hoome-section5-stat-sub">{item.sub}</div>
            </div>
        </div>
    );
}

// Sustainability section stat card with animation
function SustainabilityStatCard({ item }) {
    return (
        <div className="home-section6-stat-card">
            <div className="home-section6-icon" style={{ background: item.bg }}>
                <img src={item.icon} alt={item.sub} className="home-section6-icon-img" />
            </div>
            <div>
                <div className="home-section6-home-section3-stat-title">
                    <AnimatedCounter value={item.title} className="home-section6-home-section3-stat-title" />
                </div>
                <div className="home-section6-stat-sub">{item.sub}</div>
            </div>
        </div>
    );
}

const verticals = [
    {
        color: "#01589B",
        icon: homeAPIIcon,
        title: "API",
        link: "/api",
        desc: "Active Pharmaceutical Ingredients manufactured to the highest global standards",
        points: [
            "Regulatory accredited manufacturing facilities",
            "Manufacturing capacity – 2,300 KL+",
            "End to End Quality excellence",
            "Robust scientific, regulatory and ESG driven organization",
            "Multi-scale reactor capabilities (100 Liter to 15 KL)",
        ],
    },
    {
        color: "#F97316",
        icon: homeHumanHealthIcon,
        title: "Human Health",
        link: "/human-health",
        desc: "Comprehensive pharmaceutical solutions for improving human healthcare",
        points: [
            "End to end FDF development and manufacturing",
            "USFDA compliant facility",
            "Strong R&D and Quality control",
            "Integrated analytical development, validation and quality system",
            "Strong regulatory support including ANDA filing, IP evaluation and pharmacovigilance",
        ],
    },
    {
        color: "#22C55E",
        icon: homeAnimalHealthIcon,
        title: "Animal Health",
        link: "/animal-health",
        desc: "Veterinary pharmaceuticals ensuring animal wellness and productivity",
        points: [
            "India’s first & largest global integrated animal health company",
            "Among Top 25 animal companies in the world",
            "GMP approved facilities",
            "World-class Advanced manufacturing facilities",
            "Specialise in animal health APIs & finished dosage formulation",
            "Strong R&D and Quality control",
        ],
    },
    {
        color: "#0EA5E9",
        icon: homeCDMOServicesIcon,
        title: "CDMO Services",
        link: "/cdmo",
        desc: "End-to-end contract development and manufacturing organization",
        points: [
            "Custom synthesis capabilities",
            "Dedicated suite to handle OEB 4/5 products",
            "Dedicated block for HPAPI / cytotoxic APIs",
            "Advance analytical instrumentation to support product development and characterization",
        ],
    },
];

export default function Home() {
    // Image slider state
    const sliderImages = [
        homeSectionRightImg1,
        homeSectionRightImg2,
        homeSectionRightImg3,
        homeSectionRightImg4,
        homeSectionRightImg5,
    ];
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [sliderImages.length]);

    // ========================
    //  SCROLL REVEAL ANIMATIONS
    // ========================
    useEffect(() => {
        // Pre-mark all stagger children as hidden
        document.querySelectorAll("[data-stagger]").forEach((grid) => {
            Array.from(grid.children).forEach((child) => {
                child.classList.add("anim-child");
            });
        });

        // Observer for stagger grids — each child animates individually
        const staggerObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        Array.from(entry.target.children).forEach((child, i) => {
                            child.style.animationDelay = `${i * 0.13}s`;
                            child.classList.add(
                                i % 2 === 0 ? "anim-from-left" : "anim-from-right"
                            );
                        });
                        staggerObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );

        document
            .querySelectorAll("[data-stagger]")
            .forEach((el) => staggerObserver.observe(el));

        // Observer for section-level reveals
        const sectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                        sectionObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.06 }
        );

        document
            .querySelectorAll(".scroll-reveal, .sr-left, .sr-right")
            .forEach((el) => sectionObserver.observe(el));

        return () => {
            staggerObserver.disconnect();
            sectionObserver.disconnect();
        };
    }, []);

    return (
        <>
            {/* ================= SECTION 1 ================= */}
            <section className="home-section1">
                {/* Left Content — slides in from left */}
                <div className="home-section1-left sr-left">
                    <p className="home-section1-tagline">
                        Listed Company | Global Pharma Leader
                    </p>

                    <h1 className="home-section1-title">
                        Advancing Health Through <br />
                        Science & Innovation
                    </h1>

                    <p className="home-section1-desc">
                        We are an integrated pharmaceutical enterprise, defined by agility, quality commitment  with a customer centric approach.

                        <br />

                        <span>We are Viyash!</span>
                    </p>

                    <div className="home-section1-buttons">
                        <a href="/about" className="home-section1-btn-outline">Read More</a>
                        <a href="/contact" className="home-section1-btn-outline">Contact Us</a>
                    </div>

                    {/* Stats */}
                    <div className="home-section1-stats">
                        {stats.map((stat) => (
                            <StatItem key={stat.label} stat={stat} />
                        ))}
                    </div>
                </div>

                {/* Right Image Slider — slides in from right */}
                <div className="home-section1-right sr-right">
                    <div className="home-section1-slider">
                        {sliderImages.map((img, index) => (
                            <div
                                key={index}
                                className={`home-section1-slide${index === currentSlide ? " active" : ""}`}
                            >
                                <img
                                    src={img}
                                    alt={`Pharma Lab ${index + 1}`}
                                    className="home-section1-image"
                                />
                            </div>
                        ))}
                        <img
                            src={homeSectionRightImgbottomicon}
                            alt="Overlay Icon"
                            className="home-section1-overlay-icon"
                        />
                    </div>
                </div>
            </section>

            {/* ================= SECTION 2 ================= */}
            <section className="home-section2 scroll-reveal">
                <div className="home-section2-header">
                    <h2>Our Business Verticals</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>Four integrated business lines driving pharmaceutical excellence across the value chain</p>
                    {/* <p><b style={{fontSize: '20px', CiLineHeight :'34px'}}>Four integrated capabilities across the pharmaceutical value chain </b><br/>From intermediates and APIs to finished dosage formulations, veterinary solutions</p> */}
                </div>

                {/* Cards — each card animates individually */}
                <div className="home-section2-grid" data-stagger="true">
                    {verticals.map((v) => (
                        <div key={v.title} className="home-section2-card">
                            <div
                                className="home-section2-card-header"
                                style={{ background: v.color }}
                            >
                                <img src={v.icon} alt={v.title} className="home-section2-card-header-icon" />
                                {v.title}
                            </div>
                            <div className="home-section2-card-body">
                                <p className="home-section2-desc">{v.desc}</p>
                                <ul className="home-section2-list">
                                    {v.points.map((pt) => (
                                        <li key={pt}>{pt}</li>
                                    ))}
                                </ul>
                                <a
                                    href={v.link}
                                    className="home-section2-link"
                                    style={{ color: '#01589B' }}
                                >
                                    Learn More <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= SECTION 3 Global & Manufacturing Footprint ================= */}
            <section className="home-section3 scroll-reveal">
                <h2 className="home-section3-title">
                    Global Manufacturing Footprint
                </h2>
                <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                <p className="home-section3-subtitle">
                    State-of-the-art facilities across four continents
                </p>

                <div className="home-section3-map">
                    <img
                        src={homeSection3MapImage}
                        alt="Global Manufacturing Footprint Map"
                    />
                </div>

                {/* Stats — each stat animates individually */}
                <div className="home-section3-stats" data-stagger="true">
                    <div className="home-section3-stat-box">
                        <img src={homeFacilitiesIcon} alt="Facilities" className="home-section3-stat-icon" />
                        <div className="home-section3-stat-content">
                            <div className="home-section3-stat-title">
                                <AnimatedCounter value="15+" className="" />
                                <span style={{ marginLeft: "4px" }}>Facilities</span>
                            </div>
                            <p>Global Network</p>
                        </div>
                    </div>
                    <div className="home-section3-stat-box">
                        <img src={homeCountriesIcon} alt="Countries" className="home-section3-stat-icon" />
                        <div className="home-section3-stat-content">
                            <div className="home-section3-stat-title">
                                <AnimatedCounter value="150+" className="" />
                                <span style={{ marginLeft: "4px" }}>Countries</span>
                            </div>
                            <p>Market Presence</p>
                        </div>
                    </div>
                    <div className="home-section3-stat-box">
                        <img src={homeUnitsYearIcon} alt="Units/Year" className="home-section3-stat-icon" />
                        <div className="home-section3-stat-content">
                            <div className="home-section3-stat-title">
                                <AnimatedCounter value="2300+" className="" /> <span style={{ marginLeft: "4px" }}>KL</span> &nbsp;&nbsp; | &nbsp;&nbsp; <AnimatedCounter value="2.5B+" className="" /> <span style={{ marginLeft: "4px" }}>Units/Year</span>

                            </div>
                            <p>Production Capacity</p>
                        </div>
                    </div>

                    {/* <div className="home-section3-stat-box">
                        <img src={homeUnitsYearIcon} alt="Units/Year" className="home-section3-stat-icon" />
                        <div className="home-section3-stat-content">
                            <div className="home-section3-stat-title">
                                <AnimatedCounter value="2.5B+" className="" />
                                <span style={{ marginLeft: "4px" }}>Units/Year</span>
                            </div>
                            <p>Production Capacity</p>
                        </div>
                    </div> */}
                </div>

                <a href="/manufacturing-quality" className="home-section3-btn">
                    Read More
                </a>
            </section>

            {/* ================= SECTION 4 ================= */}
            <section className="home-section4 scroll-reveal">
                <div className="home-section4-header">
                    <h2 className="home-section4-title">Quality &amp; Compliance</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="home-section4-subtitle">
                        Unwavering commitment to excellence and regulatory standards
                    </p>
                </div>

                {/* Top Cards — stagger */}
                {/* 
                Global Compliance
USFDA, EU-GMP aligned

Digital Quality
LIMS-enabled data integrity

Robust QMS
CAPA, deviations, change control

Analytical Excellence
Validated, reproducible testing

Audit Readiness
Inspection-ready, risk-based systems */}

                <div className="home-section4-top-grid" data-stagger="true">
                    {[
                        { icon: homeSection4Icon1, title: "Global Compliance", sub: "USFDA, EU-GMP, WHO GMP aligned" },
                        { icon: homeSection4Icon2, title: "Digital Quality", sub: "LIMS-enabled data integrity" },
                        { icon: homeSection4Icon3, title: "Robust QMS", sub: "CAPA, deviations, change control" },
                        { icon: homeSection4Icon4, title: "Analytical Excellence", sub: "Validated, reproducible testing" },
                        { icon: homeSection4Icon4, title: "Audit Readiness", sub: "Inspection-ready, risk-based systems" },
                    ].map((item) => (
                        <div key={item.title} className="home-section4-card">
                            {/* <img src={item.icon} alt={item.title} /> */}
                            <div>
                                <div className="home-section4-card-title">{item.title}</div>
                                <div className="home-section4-card-sub">{item.sub}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Middle Row — stagger */}
                <div className="home-section4-mid-grid" data-stagger="true">
                    <div className="home-section4-image-card">
                        <img src={homeSection4Image} alt="Quality Testing" />
                        <div className="home-section4-image-overlay">
                            <div className="overlay-title">Rigorous Quality Testing</div>
                            <div className="overlay-sub">
                                Every batch undergoes comprehensive quality control procedures
                            </div>
                        </div>
                    </div>
                    <div className="home-section4-commitment">
                        <h3>Our Commitment</h3>
                        {[
                            {
                                icon: HomeCommitmentIcon1,
                                title: "Batch Integrity",
                                desc: "Complete traceability from raw materials to finished products",
                            },
                            {
                                icon: HomeCommitmentIcon2,
                                title: "Regulatory Excellence",
                                desc: "Meeting and exceeding global pharmaceutical standards",
                            },
                            {
                                icon: HomeCommitmentIcon3,
                                title: "Continuous Improvement",
                                desc: "Ongoing investment in quality systems and technologies",
                            },
                        ].map((item) => (
                            <div key={item.title} className="commit-item">
                                <div className="commit-icon">
                                    <img src={item.icon} alt={item.title} />
                                </div>
                                <div>
                                    <div className="commit-title">{item.title}</div>
                                    <div className="commit-desc">{item.desc}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Certifications — cert grid stagger */}
                {/* <div className="home-section4-cert">
                    <h3 className="home-section4-cert-title">
                        <img src={GlobalCertificationsApprovalsIcon} alt="Global Certifications & Approvals" /> Global Certifications &amp; Approvals
                    </h3>
                    <div className="home-section4-cert-grid" data-stagger="true">
                        {[
                            { icon: homeFDAIcon, title: "FDA", sub: "US Food & Drug Administration" },
                            { icon: homeEMAIcon, title: "EMA", sub: "European Medicines Agency" },
                            { icon: homeWHOGMPIcon, title: "WHO-GMP", sub: "World Health Organization" },
                            { icon: homeISO90012015Icon, title: "ISO 9001:2015", sub: "Quality Management" },
                            { icon: homeISO14001Icon, title: "ISO 14001", sub: "Environmental Management" },
                            { icon: homeOHSAS18001Icon, title: "OHSAS 18001", sub: "Occupational Health & Safety" },
                        ].map((cert) => (
                            <div key={cert.title} className="cert-item">
                                <div className="cert-icon">
                                    <img src={cert.icon} alt={cert.title} />
                                </div>
                                <div>
                                    <div className="cert-title">{cert.title}</div>
                                    <div className="cert-sub">{cert.sub}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div> */}


                <div className="cdmo-section4-certifications">

                    <div className="cdmo-section4-cert-title">
                        <img src={manufacturingApprovalsIcon} alt="Certifications" />
                        <span>Manufacturing Approvals & Certifications</span>
                    </div>

                    <div className="cdmo-section4-cert-tags">

                        {[

                            "FDA - US FOOD & DRUG ADMINISTRATION",

                            "EDQM",
                            "ANVISA",
                            "NMPA CHINA",
                            "PMDA",
                            "MFDS (KOREA – Ministry of Food and Drug Safety)",
                            "COFEPRIS",
                            "TGA",
                            "Health Canada",
                            "WHO-GMP",
                            "ISO 14001 Certified",
                            "ISO 45001 Certified"
                        ].map((tag) => (
                            <span key={tag}>{tag}</span>
                        ))}

                    </div>

                </div>

            </section>

            {/* ================= SECTION 5 ================= */}
            <section className="hoome-section5 scroll-reveal">
                <div className="hoome-section5-header">
                    <h2 className="hoome-section5-title">
                        Investor Strength & Credibility
                    </h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="hoome-section5-subtitle">
                        Transparent governance and sustainable growth trajectory
                    </p>
                </div>

                {/* Top Stats — stagger */}
                <div className="hoome-section5-top-grid" data-stagger="true">
                    {[
                        { icon: homeRevenueIcon, title: "$350 Mn", sub: "Revenue" },
                        { icon: homePatentsFiledIcon, title: "190+", sub: "Patents Filed" },
                        { icon: homeGrowthEbitdaIcon, title: "50%", sub: "Growth in EBITDA" },
                        { icon: homeNetDebtIcon, title: "70%", sub: "Net Debt to EBITDA in last 6 Quarters" },
                    ].map((item) => (
                        <InvestorStatCard key={item.title} item={item} />
                    ))}
                </div>

                {/* Bottom Two Columns — stagger */}
                <div className="hoome-section5-bot-grid" data-stagger="true">
                    <div className="hoome-section5-left">
                        <h3 className="hoome-section5-left-title">Key Strengths</h3>
                        {[
                            "200+ scientists and strong R&D backbone with expertise in complex chemistry, HPAPI and cytotoxic products",
                            "Integrated platform with backward integration and low import dependency",
                            "Dedicated Human Health / Animal Health formulation with diversified dosage expertise",
                            "Advanced high-potency and complex molecule handling",
                            "Robust quality and compliance framework aligned with USFDA, EMA and global standards",
                            "Scalable multi-site manufacturing operation designed for long-term growth.",
                        ].map((point, i) => (
                            <div key={i} className="hoome-section5-point">
                                <div className="hoome-section5-number">{i + 1}</div>
                                <p>{point}</p>
                            </div>
                        ))}
                    </div>
                    <div className="hoome-section5-right">
                        <h3 className="hoome-section5-right-title">Investor Resources</h3>
                        {[
                            { icon: homeFinancialReportsIcon, title: "Financial Reports", sub: "Quarterly & Annual", url: '/financial' },
                            { icon: homeCorporateGovernanceIcon, title: "Corporate Governance", sub: "Board & Policies", url: '/CorporateGovernance' },
                            { icon: homeShareholderInfoIcon, title: "Shareholder Information", sub: "Meeting & Voting", url: '/shareholder-information' },
                            { icon: homeEventsEarningsIcon, title: "Events & Earnings", sub: "Calls & Presentations", url: '/contact' },
                        ].map((item) => (
                            <div key={item.title} className="hoome-section5-resource">
                                <div className="hoome-section5-resource-top">
                                    <a href={item.url}>
                                        <div className="hoome-section5-resource-icon">
                                            <img src={item.icon} alt={item.title} />
                                        </div>
                                        <div className="hoome-section5-resource-title">{item.title}</div></a>
                                </div>
                                <div className="hoome-section5-resource-sub">{item.sub}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= SECTION 6 ================= */}
            <section className="home-section6 scroll-reveal">
                <div className="home-section6-header">
                    <h2 className="home-section6-title">Sustainability & People</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="home-section6-subtitle">
                        Building a healthier, more sustainable future for all
                    </p>
                </div>

                {/* Top Stats — stagger */}
                <div className="home-section6-top-grid" data-stagger="true">
                    {[
                        { icon: homeWaterSavedIcon, bg: "#01589B", title: "40%", sub: "Water Saved" },
                        { icon: homeWasteRecycledIcon, bg: "#22C55E", title: "75%", sub: "Waste Recycled" },
                        { icon: homeEmployeeSatisfactionIcon, bg: "#F97316", title: "92%", sub: "Employee Satisfaction" },
                    ].map((item) => (
                        <SustainabilityStatCard key={item.sub} item={item} />
                    ))}
                </div>

                {/* Middle Cards — stagger */}
                <div className="home-section6-mid-grid" data-stagger="true">
                    {[
                        {
                            icon: homeEnvironmentalStewardshipIcon,
                            title: "Environmental Stewardship",
                            points: [
                                "Carbon neutral by 2050",
                                "Water consumption reduction",
                                "Zero waste program",
                                "Renewable energy transition",
                            ],
                        },
                        {
                            icon: homePeopleCultureIcon,
                            title: "People & Culture",
                            points: [
                                "4,000+ skilled employees",
                                "Continuous learning & development",
                                "Diversity & inclusion programs",
                                "Health & safety excellence",
                            ],
                        },
                        {
                            icon: homeSocialImpactIcon,
                            title: "Social Impact",
                            points: [
                                "Accessible medicines initiative",
                                "Community health programs",
                                "Education partnerships",
                                "Local employment generation",
                            ],
                        },
                    ].map((card) => (
                        <div key={card.title} className="home-section6-card">
                            <div className="home-section6-card-header">
                                <span>
                                    <img className="home-section6-card-icon" src={card.icon} alt={card.title} />
                                </span>
                                <span className="home-section6-card-title">{card.title}</span>
                            </div>
                            <div className="home-section6-card-body">
                                {card.points.map((pt) => (
                                    <div key={pt} className="home-section6-point">
                                        <span className="home-section6-dot"></span>
                                        <span className="home-section6-point-text">{pt}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="home-section6-banner">
                    <div className="home-section6-banner-icon">
                        <img src={homeUNSDGsIcon} alt="UN Sustainable Development Goals" />
                    </div>
                    <h3 className="home-section6-banner-title">
                        UN Sustainable Development Goals
                    </h3>
                    <p className="home-section6-banner-text">
                        Aligned with global sustainability frameworks to create lasting positive impact
                    </p>
                    <a href="/sustainability" className="home-section6-button">
                        View Sustainability Report
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </a>
                </div>
            </section>

            {/* ================= SECTION 7 ================= */}
            <section className="home-section7 scroll-reveal">
                <div className="home-section7-header">
                    <h2>How Can We Help You?</h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>Choose your pathway to connect with Viyash</p>
                </div>

                {/* Cards — stagger */}
                <div className="home-section7-cards-grid" data-stagger="true">
                    {[
                        {
                            icon: homeCustomersIcon,
                            title: "Customers",
                            desc: "Premium pharmaceutical solutions tailored to your needs",
                            links: [
                                { label: "Request Quote", url: "/contact" },
                                { label: "View Capabilities", url: "/cdmo" }
                            ]
                        },
                        {
                            icon: homePartnersIcon,
                            title: "Partners",
                            desc: "Strategic collaboration and licensing opportunities",
                            links: [
                                { label: "Partnership Info", url: "/contact" },
                                { label: "Licensing", url: "/contact" }
                            ]
                        },
                        {
                            icon: homeInvestorsIcon,
                            title: "Investors",
                            desc: "Financial insights and shareholder information",
                            links: [
                                { label: "Investor Relations", url: "/investors" },
                                { label: "View Reports", url: "/investors#financial-results" }
                            ]
                        },
                        {
                            icon: homeCareersIcon,
                            title: "Careers",
                            desc: "Join our team of healthcare innovators",
                            links: [
                                { label: "Open Positions", url: "/careers" },
                                { label: "Life at Viyash", url: "/careers" }
                            ]
                        }
                    ].map((card) => (
                        <div key={card.title} className="home-section7-card">
                            <div className="home-section7-card-header">
                                <img src={card.icon} alt={card.title} className="home-section7-icon" />
                                <div>
                                    <h4>{card.title}</h4>
                                    <p>{card.desc}</p>
                                </div>
                            </div>
                            <div className="home-section7-card-links">
                                {card.links.map((link) => (
                                    <a key={link.label} href={link.url}>
                                        {link.label}
                                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#6B7280" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                        </svg>
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="home-section7-banner">
                    <img src={homeNotSureIcon} alt="Not sure where to start?" className="home-section7-banner-icon" />
                    <h3>Not sure where to start?</h3>
                    <p>
                        Our dedicated team is here to guide you to the right solution for your needs
                    </p>
                    <a href="/contact" className="home-section7-btn">
                        Contact Us
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </a>
                </div>
            </section>
        </>
    );
}